<template>
	
	<label class="filter">

		<input type="checkbox" v-bind:value="value" v-bind:checked="isActive" v-on:click="handleChange">

		<span class="filter__label">{{ label }}</span>

		<span class="badge badge--number">{{ jobs }}</span>
		
	</label>

</template>
 
<script>
export default {
	props: {
		groupKey: String,
		optionIndex: Number,
		label: String,
		value: [String, Number],
		jobs: Number
	},
	computed: {
		isActive: function() {
			return this.$store.state.selectedFilters[this.groupKey].includes(this.value)
		}
	},
	methods: {
		handleChange(e) {
			console.log(e.target.checked);

			const commitData = {
				type: this.groupKey,
				value: this.value
			}

			let mutationType = null

			switch(e.target.checked) {
				case true:
					mutationType = 'filterSelect'
					break
				case false:
					mutationType = 'filterRemove'
					break
			}
			
			if (mutationType !== null) {

				this.$store.commit(
					mutationType,
					commitData
				)
			}
		}
	}
}
</script> 